import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getCompanyImage = createAsyncThunk('/company_image/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyImage/${userId}`, {})
    return response.data;
})

export const companyImageSlice = createSlice({
    name: 'company_image',
    initialState: {
        isLoading: false,
        company_image: []
    },

    /*extraReducers: {
        [getCompanyImage.pending]: state => {
            state.isLoading = true
        },
        [getCompanyImage.fulfilled]: (state, action) => {
            state.company_image = action.payload.data
            state.isLoading = false
        },
        [getCompanyImage.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getCompanyImage.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCompanyImage.fulfilled, (state, action) => {
                state.company_image = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getCompanyImage.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default companyImageSlice.reducer